import React from 'react';
import Remarkable from 'react-remarkable';
import {
  HistoryContainer,
  HistoryTitle,
  ThreadContainer,
  ThreadItem,
  UserText,
  AIText,
  ContentBody,
  Timestamp,
} from './InteractionHistoryCSS';

const InteractionHistory = ({ thread }) => {
  if (!thread || thread.length === 0) {
    // return null;
  }

  return (
    <HistoryContainer>
      <HistoryTitle>Historique des conversations</HistoryTitle>
      <ThreadContainer>
        {thread.map((interaction, index) => (
          <ThreadItem key={`thread-item-${interaction.id || index}`}>
            {interaction.response && (
              <AIText>
                <ContentBody>AI - {interaction.response}</ContentBody>
              </AIText>
            )}

            {interaction.aiResponse && (
              <AIText>
                <ContentBody>
                  AI -<Remarkable source={interaction.aiResponse || ''} />
                </ContentBody>
              </AIText>
            )}

            {interaction.question && (
              <UserText>
                <ContentBody>
                  <b>
                    YOU -{' '}
                    {interaction.question ||
                      interaction.data?.question ||
                      interaction.payload?.interactionData?.question ||
                      'Question'}
                  </b>
                </ContentBody>
              </UserText>
            )}

            {interaction.timestamp && (
              <Timestamp>
                {new Date(interaction.timestamp).toLocaleString()}
              </Timestamp>
            )}
          </ThreadItem>
        ))}
      </ThreadContainer>
    </HistoryContainer>
  );
};

export default InteractionHistory;
